// extracted by mini-css-extract-plugin
export default {"bsui-select":"bsui-select--90928f","bsuiSelect":"bsui-select--90928f","bsui-select__control":"bsui-select__control--24c60a","bsuiSelect__control":"bsui-select__control--24c60a"};